export const backPopupMessage = {
    title: "Are you sure want to leave",
    desc: "Looks like you have not submitted your bank statement. Your application will remain incomplete without submitting bank statement.",
};

const defaultErrorMsg = "Couldn't process the request, please try again";

export enum bsUploadType {
    PDF = "PDF",
    NET_BANKING = "NET_BANKING",
}

export const getErrorMessages = (body: any) => {
    let message: string;
    if (!body["response"]) {
        message = defaultErrorMsg;
    } else {
        body = body["response"]["data"];
        if (body["error"] && body["error"]["message"]) {
            message = body.error.message;
        } else {
            message = defaultErrorMsg;
        }
    }
    return message;
};

export const getUploadErrors = {
    0: "Invalid document. Please upload pdf of your bank statement",
    2: "Not able to process. Please email your bank statements to onboarding@myshubhlife.com",
    3: "Incorrect password. Please enter correct password to upload bank statement",
    4: "Your bank name doesn't match with uploaded bank statement. Please select right bank name",
    5: "Your bank name doesn't match with uploaded bank statement. Please select right bank name",
    6: "Incorrect file format. Please enter correct bank statement in pdf format",
    7: "Unsupported Bank Statement Format. It should have balance, date and amount",
};

export enum bsVendor {
    FINBOX = "FINBOX",
};
